<template>
  <picker-field :label="label" :value="value" title="选择联系人" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.value"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.display}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: {
      type: String,
      default: "联系人"
    },
    value: String,
    vendorId: Number
  },
  data() {
    return {
      items: []
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.display);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/document/vendor/getContactCombo",
        params: {
          id: me.vendorId
        }
      }).then(function(res) {
        if (res.success) {
          me.items = res.data;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>